import React, { Component } from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import Buttons from "../../../../Components/UI/Buttons";
import Icons from "../../../../Components/Icons/Icons";

class GridListing extends Component {
	constructor(props) {
        super(props);
    }

    clickHandler = ()=>{

    }

    callGridHtml = () => {
        const tableData = this.props.tableRecords.tableData;
        if(tableData.status===200 && tableData.data.length>0){
                let folderHtml = '';
                let filesHtml = '';
                let folderArr = [];
                let filesArr = [];
                tableData.data.forEach((rows)=>{
                    let rowsData = (rows.gData)?rows.gData:rows;
                    // let actionData = (rows.data)?rows.data:rows;
                    // console.log(rowsData,'rowsData')                    
                    if(rowsData.type){
                        filesArr.push(rowsData)
                    }else{
                        folderArr.push(rowsData)                    
                    }
                }) 
                //console.log(filesArr,'filesArr')

                folderHtml = folderArr.map((item, index) => {                    
                    return(
                        <Wrp key={`folder${index}`}>
                            <div className="col-md-4">
                                <div className="card card-stats card-round icon_hover" style={{background:'#f8f8f8', boxShadow:'none',border:'1px solid #dfe2f3'}}>
                                    <div className="card-body cursor-pointer" onClick={this.props.assignListingModules.bind(this,'Directory',item.id)}>
                                        <div className="row align-items-center">
                                            <div className="col-12">
                                                <div className="icon-big text-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 512 512" viewBox="0 0 512 512" width="24" height="24"><path fill="#F6B44B" d="M457.2 66.1H33.8v132.6h444.4V87.1C478.2 75.5 468.8 66.1 457.2 66.1zM198.2 4.3H54.8c-11.6 0-21 9.4-21 21v40.8h185.5V25.3C219.3 13.7 209.9 4.3 198.2 4.3z"/><rect width="339.8" height="102.1" x="86.1" y="94.7" fill="#F2F2F2"/><rect width="140.4" height="12.9" x="121.1" y="118.8" fill="#65C5B8"/><rect width="269.7" height="12.9" x="121.1" y="160" fill="#89D6F7"/><path fill="#FFD05C" d="M489,196.8H23c-12.8,0-22.7,11.4-20.8,24.1l39.7,268.8c1.5,10.3,10.4,18,20.8,18h386.6   c10.4,0,19.3-7.6,20.8-18L509.8,221C511.6,208.3,501.8,196.8,489,196.8z"/></svg>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="numbers d-flex align-items-center justify-content-between">
                                                    <h4 className="card-title "> <label className="text-truncate w-100"> {item.name} </label>  </h4>           
                                                    <i className="fas fa-chevron-right text-small"></i>                                                                                             
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Wrp>
                    )
                })

                filesHtml = filesArr.map((item, index) => {                
                    return(
                            <div className="col-md-4" key={`files${index}`}>
                                <div className="card card-stats"  style={{background:'#f8f8f8', boxShadow:'none',border:'1px solid #dfe2f3'}}>
                                    <div className="card-body ">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="icon-big text-center">
                                                    {/* <i className="far fa-file-excel fa-2x text-success"></i> */}
                                                    
                                                    
                                                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 2" viewBox="0 0 32 32" width="28" height="28"><rect width="20.91" height="24.44" x="7.58" y="1.75" fill="#bed4ea" rx="3.25" ry="3.25"/><path fill="#192965" d="M21.17,30.75H6.76A3.76,3.76,0,0,1,3,27V9.06A3.76,3.76,0,0,1,6.76,5.31H21.17a3.76,3.76,0,0,1,3.75,3.75V27A3.75,3.75,0,0,1,21.17,30.75ZM6.76,6.81A2.25,2.25,0,0,0,4.51,9.06V27a2.25,2.25,0,0,0,2.25,2.25H21.17A2.25,2.25,0,0,0,23.42,27V9.06a2.25,2.25,0,0,0-2.25-2.25Z"/><path fill="#192965" d="M20.37 12.81H7.57a.75.75 0 0 1 0-1.5h12.8a.75.75 0 0 1 0 1.5zM20.37 18.78H7.57a.75.75 0 0 1 0-1.5h12.8a.75.75 0 1 1 0 1.5zM14 24.75H7.57a.75.75 0 0 1 0-1.5H14a.75.75 0 0 1 0 1.5z"/></svg>
                                                    
                                                </div>
                                                <a data-toggle="dropdown" aria-expanded="false" className="icon-right mr-2 dropdown-toggle dropdown-menu-right hidden-caret" style={{top:'0'}}>
                                                    <Icons iconType={'EllipsisV'}/>
                                                </a>
                                                <span class="dropdown-menu dropdown-menu-right">
                                                    <Buttons buttonList={item.actionMore} />
                                                </span>
                                            </div>
                                            <div className="col-12">
                                                <div className="numbers text-center">
                                                    <h4 className="card-title"> <label className="text-truncate w-100"> {item.name} </label></h4>                                                                                                        
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    )
                })

                return(
                    <Wrp key={`folder`}>
                        <div className="row">
                            <div className="col-12">
                                <h6 className="border-bottom"> Folders </h6>
                            </div>
                            {folderHtml}
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <h6 className="border-bottom"> Files </h6>
                            </div>
                            {filesHtml}
                        </div>

                            
                    </Wrp>
                )                    
            
        }else{
            return( 
            <Wrp key={'emt'}>           
                <div className="row">
                    
                    <div className="col-sm-12 col-md-3">
                        <div className="card card-stats card-round icon_hover"  style={{background:'#f8f8f8', boxShadow:'none'}}>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-12">
                                        No Record exists
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Wrp>            
            )

        }
          
    }

    render () {
        //console.log('GridListing');
    	// const tableHead = this.props.tableRecords.tableHead;
        // const tableData = this.props.tableRecords.tableData;
        let tableHeader = [];        
        let ClassName = ['table','mb-0'];

    	return(
    		<Wrp>
    			{this.callGridHtml()}
    		</Wrp>
    	)
    }
}

export default GridListing;
